<template>
  <b-row>
    <b-col>
      <b-row class="mb-0">
        <b-col>
          <h5 class="o-express-header">
            Clients - Express Configuration
          </h5>
        </b-col>
        <b-col
          class="text-right"
          cols="auto"
        >
          <toggle-button
            v-model="settings.showSecrets"
            class="mb-0 mr-2"
            :height="24"
            :width="60"
            :sync="true"
          />Show Secrets
        </b-col>
      </b-row>
      <template v-for="(platform, platformIndex) in platforms">
        <platform-clients
          :key="'platform.id' + platformIndex"
          :platform="platform"
          :platform-index="platformIndex"
          :settings="settings"
          @reportexec-baseurl-changed="handleReportExecBaseUrlChanged"
        />
      </template>
      <b-row>
        <b-col
          cols="12"
          md="auto"
        >
          <b-form-textarea
            id="copy-client-config"
            style="position: absolute; height: 0; z-index: -1"
          />
          <b-button
            size="sm"
            style="
              padding-left: 15px !important;
              padding-right: 15px !important;
            "
            @click="copyClientConfig"
          >
            <i class="fa fa-copy" />&nbsp; Copy Client Configuration
          </b-button>
        </b-col>

        <!-- copy sql script -->
        <b-col
          cols="12"
          md="auto"
        >
          <b-form-textarea
            id="copy-client-sqlscript"
            style="position: absolute; height: 0; z-index: -1"
          />
          <div v-if="isReportExecPlatformInUse()">
            <b-button
              size="sm"
              style="
                padding-left: 15px !important;
                padding-right: 15px !important;
              "
              @click="copySqlClientConfig"
            >
              <i class="fa fa-copy" />&nbsp; Copy Client SQL-Script 
            </b-button>
          </div>
        </b-col>

        <b-col
          cols="12"
          md="auto"
        >
          <b-alert
            variant="success"
            :show="settings.showCopyAlert"
            style="padding-top: 6px; padding-bottom: 6px; margin-bottom: 0"
          >
            {{ alertMessage }}
          </b-alert>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import PlatformClients from "@/components/tenants/clients/PlatformClients.vue";
export default {
  components: {
    PlatformClients,
  },
  props: {
    data: {
      alertMessage : String,
      type: Object,
      required: true,
    },
    subdomain: {
      type: String,
      required: true
    },
  },
  data() {
    return this.data;
  },
  created() {
    this.alertMessage = "";
  },
  methods: {
    handleReportExecBaseUrlChanged(baseUrl) {
      this.$emit('reportexec-baseurl-changed', baseUrl);
    },
    normalizeNibrsMfeUrlByEnvironment(url) {
      var newUrl = "";
      if (window.location.origin.includes("localhost"))
        newUrl = url.replace("https://nibrsmfe.omnigo.one", window.location.origin);
      else if (window.location.origin.includes("-dev"))
        newUrl = url.replace("nibrsmfe", "nibrsmfe-dev");
      else if (window.location.origin.includes("-qa"))
        newUrl = url.replace("nibrsmfe", "nibrsmfe-qa");
      else
        newUrl = url;
      return newUrl;
    },
    copyClientConfig() {
      var textarea = document.getElementById("copy-client-config");
      textarea.value = JSON.stringify(this.getCopyData(), null, 2);
      textarea.select();
      textarea.setSelectionRange(0, 99999); // For mobile devices
      document.execCommand("copy");
      this.alertMessage = "Client configuration successfully copied!";
      var that = this;
      that.settings.showCopyAlert = true;
      setTimeout(function () {
        that.settings.showCopyAlert = false;
      }, 5000);
    },
    getCopyData() {
      const platforms = this.platforms;
      const copyClients = [];

      for (let i = 0; i < platforms.length; i++) {
        const platform = platforms[i];

        if (!platform.inUse) {
          continue;
        }

        const clients = platform.clients;

        for (let j = 0; j < clients.length; j++) {
          const client = clients[j];

          if (client.inUse) {
            copyClients.push(this.copyClient(client, platform.baseUrl));
          }
        }
      }

      return {
        clients: copyClients,
      };
    },
    copyClient(summary, baseUrl) {
      const client = {
        clientName: summary.clientName,
        clientId: summary.clientId,
      };

      if (summary.requireClientSecret) {
        client.clientSecret = summary.clientSecret;
      }

      if (baseUrl && baseUrl.substring(baseUrl.length - 1) === "/") {
        baseUrl = baseUrl.substring(0, baseUrl.length - 1);
      }
      
      if (summary.clientName === "WebDispatch") {
        client.postLogoutRedirectUris = (summary.webDispatchUri.endsWith("/") ? summary.webDispatchUri.substring(0, summary.webDispatchUri.length - 1) : summary.webDispatchUri);
        client.redirectUri = client.postLogoutRedirectUris + summary.redirectUri;
        client.allowedCorsOrigins = [ client.postLogoutRedirectUris ];
      } else if (summary.clientName === "Omnigo Console") {
        const subdomain = this.getSubDomain(baseUrl);
        const env = this.getEnv();
        client.authority = `https://${subdomain}${env}.auth.omnigo.one`;
      } else {
        client.redirectUri = 
          (summary.requireClientSecret ? baseUrl : "") + 
          this.normalizeNibrsMfeUrlByEnvironment(summary.redirectUri);

        client.postLogoutRedirectUris =
          (summary.requireClientSecret ? baseUrl : "") +
          summary.postLogoutRedirectUri;
      }
      return client;
    },

    //*********************************************************************************************************
    //** Generate Sql Script for Rex Platform Clients
    //*********************************************************************************************************

    // show/hide copy sql script button
    isReportExecPlatformInUse() {
      return this.platforms.some(p => p.inUse && p.name.toUpperCase() == "REPORT EXEC" && p.baseUrl !== "");
    },
    
    getRexPlatformData(){
      const platforms = this.platforms;
      let platformBaseUrl = "";
      const copyClients = [];

      for (let i = 0; i < platforms.length; i++) {
        const platform = platforms[i];

        if (!(platform.inUse && platform.baseUrl !== "" && platform.name.toUpperCase() == "REPORT EXEC")) {
          continue;
        }
        platformBaseUrl = platform.baseUrl;

        for (let j = 0; j < platform.clients.length; j++) {
          const client = platform.clients[j];
          if (client.inUse) {
            copyClients.push(this.copyClient(client, platform.baseUrl));
          }
        }
      }
      return {
        baseUrl : platformBaseUrl,
        clients : copyClients
      }
    },
    // copy the sql script text to the clipboard
    copySqlClientConfig() {
      var textarea = document.getElementById("copy-client-config");
      textarea.value =this.getRexSqlScript();
      textarea.select();
      textarea.setSelectionRange(0, 99999); // For mobile devices
      document.execCommand("copy");
      this.alertMessage = "Sql-Script successfully copied!";
      var that = this;
      that.settings.showCopyAlert = true;
      setTimeout(function () {
        that.settings.showCopyAlert = false;
      }, 5000);
    },
    getRexSqlScript(){
      // get an object with the needed params to build the sql document
      const env = this.getEnv()
      const platformData = this.getRexPlatformData();
      let clientDict = Object.assign({}, ...platformData.clients.map((x) => ({ [x.clientName] : x })));
      const subdomain = this.subdomain;
      return `
--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
-- Generated by: Omnigo Auth Admin Portal at ${new Date().toLocaleString().replace(",","")}
-- Env: ${env === ".dev" ? "DEV" : env === ".qa" ? "QA" : env === ".demo" ? "DEMO" : "PROD"} 
-- Customer: ${subdomain}
-- NIBRS Micro Frontend Client Id: ${clientDict["NIBRS Micro Frontend"] != undefined ? clientDict["NIBRS Micro Frontend"].clientId : "Client not in use" }
-- WD Client Id: ${clientDict["WebDispatch"] != undefined ? clientDict["WebDispatch"].clientId : "Client not in use" }
--
-- Enable Omnigo Auth (uncomment if needed)
--UPDATE [Data] SET [Data] = 'TRUE' WHERE [Datatype] = 'OmnigoSecurityEnabled'
--
-- Switch Authentication Mode to Omnigo (uncomment if needed)
--UPDATE [Data] SET [Data] = 'OMNIGO' WHERE [Datatype] = 'AuthenticationMode'
--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=

BEGIN TRAN

--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
-- Check for Security Identifier
--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
IF NOT EXISTS (SELECT 1 FROM [dbo].[Data] WHERE [Datatype] = 'OmnigoSecurityExternalIdentifier')
INSERT INTO [dbo].[Data] ([Datatype],[Data])
VALUES ('OmnigoSecurityExternalIdentifier','ExternalID')
 
--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
-- Omnigo Security Authority
--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
${this.getSqlUpdateSecurityAuthority(env, subdomain)}

--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
-- Report Exec Dispatch
--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
${clientDict["Report Exec Dispatch"] != undefined ? this.getSqlUpdateClientId(clientDict["Report Exec Dispatch"], 'OmnigoSecurityDispatch') : "-- No Updates. Client not in use" }

--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
-- Report Exec Mobile
--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
${clientDict["Report Exec Mobile"] != undefined ? this.getSqlUpdateClientId(clientDict["Report Exec Mobile"], 'OmnigoSecurityMobile') : "-- No Updates. Client not in use" }

--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
-- Omnigo Community Mobile
--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
${clientDict["Omnigo Community Mobile"] != undefined ? this.getSqlUpdateClientId(clientDict["Omnigo Community Mobile"], 'OmnigoSecurityCommunity') : "-- No Updates. Client not in use" }

--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
-- Report Exec Admin
--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
${clientDict["Report Exec Admin"] != undefined ? this.getSqlUpdate(clientDict["Report Exec Admin"], 'OmnigoSecurityAdmin') : "-- No Updates. Client not in use" }

--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
-- Report Exec User
--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
${clientDict["Report Exec User"] != undefined ? this.getSqlUpdate(clientDict["Report Exec User"], 'OmnigoSecurityUser') : "-- No Updates. Client not in use" }

--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
-- Report Exec 360
--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
${clientDict["Report Exec 360"] != undefined ? this.getSqlUpdate(clientDict["Report Exec 360"], 'OmnigoSecurity360') : "-- No Updates. Client not in use" }

--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
-- Omnigo Community Web
--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
${clientDict["Omnigo Community Web"] != undefined ? this.getSqlUpdate(clientDict["Omnigo Community Web"], 'OmnigoSecurityCommunityWeb') : "-- No Updates. Client not in use" }

--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
-- Report Exec Dispatch Mobile
--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
${clientDict["Report Exec Dispatch Mobile"] != undefined ? this.getSqlUpdate(clientDict["Report Exec Dispatch Mobile"], 'OmnigoSecurityDispatchMobile') : "-- No Updates. Client not in use" }

--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
-- Web Dispatch
--=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=
${clientDict["WebDispatch"] != undefined && clientDict["WebDispatch"].allowedCorsOrigins != '' ? this.getSqlDataUpdate(clientDict["WebDispatch"].allowedCorsOrigins + "/api", 'WebDispatchUrl') : "-- No Updates. Client not in use" }

COMMIT TRAN
`
    },
    getSqlDataUpdate(data, dataType, dataDelimiter = "'") {
      return `UPDATE [dbo].[Data] SET [Data] = ${dataDelimiter}${data}${dataDelimiter} 
WHERE [Datatype] = '${dataType}'`;
    },
    getSqlUpdateSecurityAuthority(env, subdomain){
      return this.getSqlDataUpdate(`https://${subdomain}${env}.auth.omnigo.one`, "OmnigoSecurityAuthority");
    },
    getSqlUpdateClientId(client, dataTypePrefix){
      return this.getSqlDataUpdate(`${client.clientId}`, `${dataTypePrefix}ClientId`);
    },
    getSqlUpdate(client, whereClause){
      return this.getSqlDataUpdate(client.clientId, `${whereClause}ClientId`) + "\n" + 
        this.getSqlDataUpdate(client.clientSecret, `${whereClause}ClientSecret`) + "\n" +
        this.getSqlDataUpdate("ISNULL ([dbo].[fnEncDecRc4]('',[Data]),'')", `${whereClause}ClientSecret`, "") + "\n" +
        this.getSqlDataUpdate(client.redirectUri, `${whereClause}RedirectUri`) + "\n" +
        this.getSqlDataUpdate(client.postLogoutRedirectUris, `${whereClause}PostLogoutRedirectUri`);
    },
    getEnv() {
      return window.location.origin.includes("-dev") 
        ? ".dev" 
        : window.location.origin.includes("-qa") 
          ? ".qa" 
          : window.location.origin.includes("-demo")
            ? ".demo"
            : ""
    },
    getSubDomain(baseUrl) {
      var parts = baseUrl.toLowerCase().replace("http://","").replace("https://","").split('.')
      return parts.length == 0 ? "<missing base url>" : parts[0]
    },
  }
};
</script>